module.exports = __webpack_public_path__ + "media/images/become-miss-min-49ea178769222f0a74497928932a3559.png";